import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { SharedDataService } from '../../service/shared-data.service';
import { Router } from '@angular/router';
import { WebStoriesTextboxOrButton } from './web-stories-textbox';
import { StaticDataService } from '../../service/static-data.service';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { cloneDeep } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DragulaService } from 'ng2-dragula';
import { StoryContainerService } from '../story-container/story-container.service';
import { GoogleAnalyticsService } from '../../service/google-analytics.service';
import { RelatedStoryData } from './web-stories-related-story';
import { environment } from '../../../environments/environment';
export class WebStoriesComponent {
    constructor(sharedService, router, route, config, restService, http, snotify, dragulaService, storyContainerService, gaService) {
        this.sharedService = sharedService;
        this.router = router;
        this.route = route;
        this.config = config;
        this.restService = restService;
        this.http = http;
        this.snotify = snotify;
        this.dragulaService = dragulaService;
        this.storyContainerService = storyContainerService;
        this.gaService = gaService;
        this.activeFeed = 'metadata';
        this.activeTemplate = 'template';
        this.imageEnabled = false;
        this.videoEnabled = false;
        this.page_id = StaticDataService.element_page_id;
        this.save_api = StaticDataService.element_save_api;
        this.get_api = StaticDataService.element_get_api;
        this.lockAcquire_api = StaticDataService.story_lockAcquire_api;
        this.lockRelease_api = StaticDataService.story_lockRelease_api;
        this.fetchTemplates_api = StaticDataService.fetchTemplates_api;
        this.story_page_id = StaticDataService.story_page_id;
        this.all_element_api = StaticDataService.element_byids_api;
        this.cardDataFromElement = new EventEmitter();
        this.removeSavedCardData = new EventEmitter();
        this.updateContentOnParent = new EventEmitter();
        this.deleteCardfn = new EventEmitter();
        this.updateStoryData = new EventEmitter();
        this.replaceElementData = new EventEmitter();
        this.webStoryHeadline = new EventEmitter();
        this.webStorySummary = new EventEmitter();
        this.showPixabay = false;
        this.isLocked = false;
        this.changeFlag = false;
        this.selectedFile = null;
        this.uploadImageInProgress = false;
        this.showAllStory = true;
        this.showMyWorkSpace = false;
        this.wireImageDisplayUrl = this.config.get('product').wireImageDisplayUrl;
        this.imageData = [];
        this.showNonWeb = false;
        this.listImageArray = [];
        this.isLightbox = false;
        this.isPhotopopup = false;
        this.videoOptions = false;
        this.isLightboxVideo = false;
        this.emptyWebStory = true;
        this.domainConfig = {};
        this.logoUrl = null;
        this.templatesCount = 10;
        this.isLightboxCoverImage = false;
        this.enableLoader = false;
        this.designIds = ['designTab', 'design', 'designTopAlign', 'designBottomAlign', 'designLeftAlign', 'designRightAlign', 'designFontFamily',
            'designFontSize', 'designFontWeight', 'designFontColor', 'designBorderColor', 'designBGColor', 'designBorderStyle', 'designCornerRadius', 'designButtonUrl',
            'designBorderColorCheckBox', 'designBGColorCheckBox', 'designFontColorCheckBox', 'designTopBottomCenterAlign', 'designLeftRightCenterAlign', 'sizeBox', 'topPad', 'botPad', 'increaseFontSize', 'decreaseFontSize', 'selectFontSize'];
        this.buttonUrl = null;
        this.linkBoxInput = false;
        this.fontFamily = null;
        this.fontSize = null;
        this.fontStyle = null;
        this.fontColor = null;
        this.backgroundColor = null;
        this.borderColor = null;
        this.borderStyle = null;
        this.cornerRadius = null;
        this.textAnimation = null;
        this.tempText = 'Enter text here';
        this.cropperImageUrl = {
            url: null,
            data: null,
            blobData: null
        };
        this.showCropper = [];
        this.cropperUrls = [];
        this.copiedTextboxOrButton = null;
        this.coverImageEnabled = false;
        this.imageType = 'slideImage';
        this.currentSlideWords = '0';
        this.currentEditDataType = null;
        this.width = 0;
        this.topPadding = 0;
        this.bottomPadding = 0;
        this.textboxInProgress = false;
        this.wireImageList = false;
        this.internalImageList = false;
        this.domainList = '';
        this.amazonAdSearchPopup = false;
        this.options = ["10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "24", "28", "32", "36", "40", "44", "48", "72", "96"];
        this.isDropDownOpen = false;
        this.relatedStoryType = 'web-story';
        this.showRelatedStoryPopup = false;
        this.relatedStoryTempList = [];
        this.storyId = null;
        this.navigationSlideId = null;
        this.enableNavigationSlide = false;
        this.enableAffiliateLink = false;
        this.AiImageData = [];
        this.domainConfig = this.sharedService.currentDomainConfiguration;
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] &&
            this.domainConfig['config']['story']['webStoryLogoUrl']) {
            this.logoUrl = this.domainConfig['config']['story']['webStoryLogoUrl'];
        }
        else {
            this.logoUrl = "assets/images/webstories/logoHT.png";
        }
        this.enableNavigationSlide = this.sharedService.isdomainConfig('story', 'enableNavigationSlide');
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story'] &&
            this.domainConfig['config']['story']['utmFields']) {
            this.utmFields = this.domainConfig['config']['story']['utmFields'];
        }
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']) {
            if (this.domainConfig['config']['story']['wireImageList']) {
                this.wireImageList = this.domainConfig['config']['story']['wireImageList'];
            }
            if (this.domainConfig['config']['story']['internalImageList']) {
                this.internalImageList = this.domainConfig['config']['story']['internalImageList'];
            }
        }
        if (this.domainConfig && this.domainConfig['config'] && this.domainConfig['config']['story']
            && this.domainConfig['config']['story']['DomainList']) {
            this.domainList = this.domainConfig['config']['story']['DomainList'];
        }
        this.enableAffiliateLink = this.sharedService.isdomainConfig('story', 'enableAffiliateLink');
        this.fetchTemplates();
        const bag = this.dragulaService.find('slides-bag');
        if (bag === undefined) {
            dragulaService.setOptions('slides-bag', {
                copy: function (el, source) {
                    return false;
                },
                accepts: function (el, target, source, sibling) {
                    if (sibling === null) {
                        return false;
                    }
                    return true;
                },
                moves: function (el, container, handle) {
                    if (el && el.id && el.id.indexOf("navigation") > -1) {
                        return false;
                    }
                    return true;
                },
                copySortSource: false
            });
        }
        dragulaService.dropModel.subscribe((value) => {
            this.sequenceChanged();
        });
        this.cropperUrls = ["9:16"];
    }
    ngOnInit() {
        this.sharedService.sendData('storyEditor|true');
        this.snowplowAnalytics('Agency Feed');
        this.enablePixabay = this.domainConfig && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['enablePixabay'];
        if (this.slides && Object.keys(this.slides).length > 0 && this.webStory && this.webStory.elements && this.webStory.elements.length > 0) {
            this.slideIds = [...this.webStory.elements];
            this.currentSlideIndex = 0;
            this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            if (this.currentSlideElement && this.currentSlideElement['webStorySlide'] && this.currentSlideElement['webStorySlide'].length > 0) {
                this.currentTextboxOrButtonElements = this.currentSlideElement['webStorySlide'];
            }
            this.emptyWebStory = false;
            this.checkForNavigationSlide();
        }
        else if ((this.slides == null || this.slides == undefined || Object.keys(this.slides).length == 0) && this.webStory && (this.webStory.elements == null || this.webStory.elements == undefined || this.webStory.elements.length == 0)) {
            this.emptyWebStory = true;
        }
        else {
            this.snotify.error('Failed to load web story', '', this.sharedService.getConfig(false));
        }
        setTimeout(e3 => {
            this.route.queryParams.subscribe(params => {
                const source = localStorage.getItem('AIsource');
                const webStoryTemplate = JSON.parse(localStorage.getItem('webStoryTemplate'));
                if (params['AIid'] && source === 'AIWebStoryfeed') {
                    const AIGallaryid = localStorage.getItem('AIWebStoryId');
                    this.aiGalleryData = JSON.parse(localStorage.getItem(AIGallaryid));
                    this.chooseTemplateforAI(webStoryTemplate);
                }
                if (params['webStoryId']) {
                    this.webstoryData = JSON.parse(localStorage.getItem(localStorage.getItem('WebstoryId')));
                    this.uploadWebStory(webStoryTemplate);
                }
            });
        }, 100);
    }
    createFirstslide() {
        this.currentSlideElement = JSON.parse(JSON.stringify(StaticDataService.defaultSlideData));
        this.currentSlideElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        this.currentSlideElement.type = 'slide';
        this.currentSlideIndex = 0;
        this.currentSlideWords = '0';
        this.slideIds = [];
        this.useLogo("Top-Left");
        this.saveNewSlide(null);
        this.emptyWebStory = false;
    }
    ngDoCheck() {
        //Called every time that the input properties of a component or a directive are checked. Use it to extend change detection by performing a custom check.
        //Add 'implements DoCheck' to the class.
        this.setStoryHeight();
    }
    setStoryHeight() {
        this.liCount = document.getElementById("pagiSlide").getElementsByTagName("li").length;
        this.liWidth = document.getElementById("templateView").clientWidth;
        this.countSlideLi = this.liWidth / this.liCount;
        const styles = {
            'width': +this.countSlideLi - 4 + 'px'
        };
        return styles;
    }
    fetchTemplates() {
        this.restService.http_get(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.fetchTemplates_api))
            .subscribe(data => {
            if (data) {
                this.templates = [...data];
            }
        }, error => {
            this.snotify.error('Failed to fetch templates', '', this.sharedService.getConfig(false));
        });
    }
    fetchCrossDomainTemplates() {
        this.restService.http_get(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.fetchTemplates_api) + "?DomainList=" + this.domainList)
            .subscribe(data => {
            if (data) {
                this.crossDomainTemplates = [...data];
            }
        }, error => {
            this.snotify.error('Failed to fetch templates', '', this.sharedService.getConfig(false));
        });
    }
    insertImage() {
        if (!this.textboxInProgress) {
            this.imageEnabled = true;
        }
    }
    clsoeImage() {
        this.imageEnabled = false;
    }
    insertVideo() {
        if (!this.textboxInProgress) {
            this.videoEnabled = true;
        }
    }
    closeVideo() {
        this.videoEnabled = false;
    }
    snowplowAnalytics(name) {
        const ur = this.router.routerState.snapshot.url;
        this.sharedService.analyticsCall((window.location.origin + ur), 'tab', [], name);
    }
    insertSlideOnLeft() {
        if (!this.textboxInProgress) {
            if (this.slideIds == null || this.slideIds == undefined || this.slideIds.length == 0) {
                this.currentSlideIndex = 0;
            }
            this.currentSlideElement = JSON.parse(JSON.stringify(StaticDataService.defaultSlideData));
            this.currentSlideElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.currentSlideElement.type = 'slide';
            this.currentSlideWords = '0';
            this.useLogo("Top-Left");
            this.saveNewSlide("left");
        }
    }
    deleteCurrentSlide() {
        if (!this.textboxInProgress) {
            this.deleteCardfn.emit(this.currentSlideIndex);
            //this.webStory.elements.splice(this.currentSlideIndex,1);
            if (this.currentSlideIndex == (this.slideIds.length - 1)) {
                this.currentSlideIndex = this.currentSlideIndex - 1;
            }
            this.slideIds = [...this.webStory.elements];
            if (this.slideIds.length >= 1) {
                this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
                if (this.currentSlideElement && this.currentSlideElement['webStorySlide'] && this.currentSlideElement['webStorySlide'].length > 0) {
                    this.currentTextboxOrButtonElements = this.currentSlideElement['webStorySlide'];
                }
                else {
                    this.currentTextboxOrButtonElements = [];
                }
            }
            else {
                this.currentSlideElement = {};
                this.currentTextboxOrButtonElements = [];
                this.emptyWebStory = true;
            }
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
        }
    }
    insertDuplicateSlideOnRight() {
        if (!this.textboxInProgress) {
            let tempSlideElement = cloneDeep(this.currentSlideElement);
            this.currentSlideElement = tempSlideElement;
            this.currentSlideIndex = this.currentSlideIndex + 1;
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            this.saveNewSlide("right");
        }
    }
    insertSlideOnRight() {
        if (!this.textboxInProgress) {
            this.currentSlideElement = JSON.parse(JSON.stringify(StaticDataService.defaultSlideData));
            this.currentSlideElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.currentSlideElement.type = 'slide';
            this.currentSlideIndex = this.currentSlideIndex + 1;
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            this.useLogo("Top-Left");
            this.saveNewSlide("right");
        }
    }
    saveNewSlide(side) {
        this.enableLoader = true;
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api), this.sharedService.checkhrefandreplace(this.currentSlideElement), result => {
            this.enableLoader = false;
            if (result) {
                if (result.id != null) {
                    if (result.relatedStoryData != null && result.relatedStoryData.length > 0) {
                        this.navigationSlideId = cloneDeep(result.id);
                    }
                    if (this.currentSlideIndex == this.slideIds.length) {
                        this.slideIds.push(result.id);
                    }
                    else if (this.currentSlideIndex == 0) {
                        this.slideIds.unshift(result.id);
                    }
                    else {
                        let tempSlideIds1 = this.slideIds.slice(0, this.currentSlideIndex);
                        tempSlideIds1.push(result.id);
                        let tempSlideIds2 = this.slideIds.slice(this.currentSlideIndex, this.slideIds.length);
                        this.slideIds = tempSlideIds1.concat(tempSlideIds2);
                    }
                    this.webStory.elements = [...this.slideIds];
                    this.slides[result.id] = result;
                    this.slides = cloneDeep(this.slides);
                    this.cardDataFromElement.emit(result);
                    this.updateContentOnParent.emit(result);
                    this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
                    this.currentTextboxOrButtonElements = this.currentSlideElement ? this.currentSlideElement['webStorySlide'] : null;
                    console.log("currentSlideElement is " + this.currentSlideElement);
                    //if(!this.currentSlideElement.reusable) {
                    if (this.currentSlideElement.reusable) {
                        this.lockAcquire(result.id, e => { });
                    }
                    this.changeFlag = false;
                }
                else {
                    console.log("failed to save the slide");
                    if (side != null && side == "right") {
                        this.currentSlideIndex = this.currentSlideIndex - 1;
                    }
                    this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
                    this.currentSlideWords = this.getWordCountOfCurrentsSlide();
                    this.currentTextboxOrButtonElements = this.currentSlideElement ? this.currentSlideElement['webStorySlide'] : null;
                }
            }
        });
    }
    updateSlide(callback) {
        // if (this.isLocked) {
        this.enableLoader = true;
        const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
            JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
            : null;
        this.currentSlideElement['lockedByUserId'] = token.email;
        this.currentSlideElement['lockedByUserName'] = token.name;
        this.currentSlideElement.lastModifiedBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        if (this.utmFields && this.currentSlideElement.ctaLink && this.currentSlideElement.ctaLinkWithUtm != this.currentSlideElement.ctaLink) {
            this.currentSlideElement.ctaLinkWithUtm = this.currentSlideElement.ctaLink + '?' + this.utmFields;
        }
        this.restService.http_put(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
            + '/' + String(this.currentSlideElement.id) + '?autoSave=true', this.sharedService.checkhrefandreplace(this.currentSlideElement), result => {
            this.enableLoader = false;
            if (!result || result.hasOwnProperty('error')) {
                console.log('lock error failed to update the slide');
                this.isLocked = false;
                this.changeFlag = true;
                this.overrideSave();
            }
            if (result && result.id == this.currentSlideElement.id) {
                this.slides[result.id] = result;
                //this.slides[result.id] = cloneDeep(result);
                this.slides = cloneDeep(this.slides);
                this.cardDataFromElement.emit(result);
                this.updateContentOnParent.emit(result);
                this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
                this.currentTextboxOrButtonElements = this.currentSlideElement ? this.currentSlideElement['webStorySlide'] : null;
                //this.currentSlideElement['firstPublishedDate'] = result['firstPublishedDate'];
                this.changeFlag = false;
                this.removeSavedCardData.emit(result.id);
            }
            callback(result);
            // else{
            //   console.log("failed to update the slide");
            //   this.currentSlideElement=this.slides[this.webStory.elements[this.currentSlideIndex]];
            //   this.currentTextboxOrButtonElements = this.currentSlideElement['webStorySlide'];
            // }
        });
        // }else{
        //   this.overrideSave();
        //   callback(false);
        // }
    }
    lockAcquire(slideId, callback) {
        if (this.isLocked === false && slideId !== null) {
            this.enableLoader = true;
            this.restService.http_get(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
                + '?articleId='
                + String(slideId))
                .subscribe(data => {
                this.enableLoader = false;
                if (data) {
                    // console.log('acquired element => ' + data);
                    this.isLocked = true;
                    this.currentSlideElement['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
                    this.currentSlideElement['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
                }
                callback(data);
            }, error => {
                // console.log(error);
                this.enableLoader = false;
                callback(false);
            });
        }
        else {
            callback(true);
            // console.log('lock alreay acquired');
        }
    }
    lockRelease(slideId, callback) {
        if (this.isLocked === true) {
            this.enableLoader = true;
            this.restService.http_get(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
                + '?articleId='
                + String(slideId))
                .subscribe(data => {
                this.enableLoader = false;
                this.isLocked = false;
                callback(data);
            }, error => {
                this.enableLoader = false;
                callback(false);
            });
        }
        else {
            callback(true);
        }
    }
    overrideSave() {
        if (this.currentSlideElement !== null && this.currentSlideElement.id !== null) {
            if (!this.currentSlideElement.reusable) {
                this.isLocked = true;
                this.currentSlideElement['lockedByUserId'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['email'];
                this.currentSlideElement['lockedByUserName'] = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['name'];
                this.updateSlide(flag2 => { });
            }
            else {
                this.lockAcquire(this.currentSlideElement.id, flag => {
                    if (flag) {
                        this.updateSlide(flag2 => {
                            this.lockRelease(this.currentSlideElement.id, flag3 => {
                                if (!flag3) {
                                    // console.log('lock not released');
                                }
                            });
                        });
                    }
                    else {
                        console.log('lock not acquired');
                    }
                });
            }
        }
        else {
            console.log('override cancelled');
        }
    }
    changeToLeftRightSlide(side) {
        if (!this.textboxInProgress) {
            if (side == 'left') {
                this.changeCurrentSlide(this.currentSlideIndex - 1);
            }
            if (side == 'right') {
                this.changeCurrentSlide(this.currentSlideIndex + 1);
            }
        }
    }
    changeCurrentSlide(index) {
        if (!this.textboxInProgress) {
            console.log("new index is:" + index);
            if (this.currentTextboxOrButtonElementIndex != null) {
                const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButton' + this.currentTextboxOrButtonElementIndex);
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].text = elem.innerText;
                //this.currentTextboxOrButtonElements[index].text = this.htmlToPlaintext(elem.innerText);
                //console.log(this.getWordCountInSlide(this.webStory.elements[this.currentSlideIndex]));
                this.currentSlideWords = this.getWordCountOfCurrentsSlide();
                console.log(this.currentSlideWords);
                this.currentTextboxOrButtonElementIndex = null;
                this.fontFamily = null;
                this.fontSize = null;
                this.fontStyle = null;
                this.fontColor = null;
                this.backgroundColor = null;
                this.borderColor = null;
                this.borderStyle = null;
                this.cornerRadius = null;
                this.width = null;
                this.topPadding = null;
                this.bottomPadding = null;
                this.updateSlide(res => {
                    if (res) {
                        this.currentSlideIndex = index;
                        this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
                        this.currentSlideWords = this.getWordCountOfCurrentsSlide();
                        if (this.currentSlideElement && this.currentSlideElement['webStorySlide'] && this.currentSlideElement['webStorySlide'].length > 0) {
                            this.currentTextboxOrButtonElements = this.currentSlideElement['webStorySlide'];
                        }
                        else {
                            this.currentTextboxOrButtonElements = [];
                        }
                    }
                });
                elem.blur();
                return;
            }
            if (this.currentEditDataType) {
                if (this.currentEditDataType == 'creditInfo') {
                    this.updateCreditInfo(null);
                }
                if (this.currentEditDataType == 'altText') {
                    this.updateAltText(null);
                }
                if (this.currentEditDataType == 'metaTitle') {
                    this.updateSlideMetaTitle(null);
                }
                if (this.currentEditDataType == 'metaDescription') {
                    this.updateSlideMetaDescription(null);
                }
                this.currentEditDataType = null;
            }
            this.currentSlideIndex = index;
            this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            if (this.currentSlideElement && this.currentSlideElement['webStorySlide'] && this.currentSlideElement['webStorySlide'].length > 0) {
                this.currentTextboxOrButtonElements = this.currentSlideElement['webStorySlide'];
            }
            else {
                this.currentTextboxOrButtonElements = [];
            }
        }
    }
    insertTextboxOrButton() {
        if (!this.textboxInProgress) {
            if (this.currentTextboxOrButtonElements) {
                //this.currentTextboxOrButtonElements.push(new WebStoriesTextboxOrButton());
                if (this.currentSlideElement.hasSlideImage || this.currentSlideElement.hasSlideVideo) {
                    let webStoriesTextboxOrButton = new WebStoriesTextboxOrButton();
                    webStoriesTextboxOrButton.fontColor = '#FFFFFF';
                    webStoriesTextboxOrButton.borderColor = '#FFFFFF';
                    this.currentTextboxOrButtonElements.push(webStoriesTextboxOrButton);
                }
                else {
                    this.currentTextboxOrButtonElements.push(new WebStoriesTextboxOrButton());
                }
                this.currentSlideElement ? this.currentSlideElement['webStorySlide'] = this.currentTextboxOrButtonElements : null;
            }
            else {
                this.currentTextboxOrButtonElements = new Array();
                //this.currentTextboxOrButtonElements.push(new WebStoriesTextboxOrButton());
                if (this.currentSlideElement.hasSlideImage || this.currentSlideElement.hasSlideVideo) {
                    let webStoriesTextboxOrButton = new WebStoriesTextboxOrButton();
                    webStoriesTextboxOrButton.fontColor = '#FFFFFF';
                    webStoriesTextboxOrButton.borderColor = '#FFFFFF';
                    this.currentTextboxOrButtonElements.push(webStoriesTextboxOrButton);
                }
                else {
                    this.currentTextboxOrButtonElements.push(new WebStoriesTextboxOrButton());
                }
                this.currentSlideElement ? this.currentSlideElement['webStorySlide'] = this.currentTextboxOrButtonElements : null;
            }
            //console.log(this.getWordCountInSlide(null));
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            console.log(this.currentSlideWords);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElements.length - 1].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElements.length - 1));
            this.updateSlide(res => {
                if (res.id) {
                    setTimeout(() => {
                        this.focusElement(this.currentSlideElement.id + 'textboxOrButton' + (this.currentSlideElement.webStorySlide.length - 1));
                    }, 3000);
                }
            });
        }
    }
    focusElement(id) {
        if (id) {
            const elem = document.getElementById(id);
            elem.focus();
            this.textboxInProgress = true;
            if (this.currentSlideElement && this.currentSlideElement.webStorySlide) {
                this.currentTextboxOrButtonElementIndex = this.currentSlideElement.webStorySlide.length - 1;
                this.fontFamily = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].fontFamily);
                this.fontSize = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].fontSize);
                this.fontStyle = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].fontStyle);
                this.fontColor = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].fontColor);
                this.backgroundColor = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySJlide.length - 1].backgroundColor);
                this.borderColor = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].borderColor);
                this.borderStyle = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].borderStyle);
                this.cornerRadius = cloneDeep(this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].cornerRadius);
                this.width = cloneDeep((this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].width) + ''.replace('%', ''));
                this.topPadding = cloneDeep((this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].topPadding) + ''.replace('%', ''));
                this.bottomPadding = cloneDeep((this.currentTextboxOrButtonElements[this.currentSlideElement.webStorySlide.length - 1].bottomPadding) + ''.replace('%', ''));
            }
        }
    }
    trackByFn(index, item) {
        return index;
    }
    getSlideStyles(slideId) {
        let styles = {};
        if ((this.currentSlideElement.id == slideId) && this.currentSlideElement.hasSlideImage) {
            styles = Object.assign(styles, { background: "url(" + (this.currentSlideElement.image.images['900x1600'] ? this.currentSlideElement.image.images['900x1600'] : this.currentSlideElement.image.images['original']) + ") no-repeat" }, { "background-size": "auto 100%" }, { "background-position": "center center" });
        }
        else if (this.currentSlideElement.id == slideId && this.navigationSlideId != null && slideId == this.navigationSlideId && this.currentSlideElement.relatedStoryData.length == 1 && this.currentSlideElement.relatedStoryData[0].coverImageUrl) {
            styles = Object.assign(styles, { background: "url(" + this.currentSlideElement.relatedStoryData[0].coverImageUrl + ") no-repeat" }, { "background-size": "auto 100%" }, { "background-position": "center center" });
        }
        return styles;
    }
    getStyles(index) {
        let currentSlideElement = this.currentTextboxOrButtonElements[index];
        // const styles = {
        //   'top': + index*10 + 20 + '%'
        // };
        // let styles = {
        //   backgroundColor: 'ivory',
        //   color: 'maroon'
        // }
        // styles = Object.assign(styles,{ top: '20%'})
        let styles = {};
        if (this.currentTextboxOrButtonElements[index].position) {
            styles = Object.assign(styles, { position: this.currentTextboxOrButtonElements[index].position });
        }
        if (this.currentTextboxOrButtonElements[index].leftMargin) {
            styles = Object.assign(styles, { left: this.currentTextboxOrButtonElements[index].leftMargin });
        }
        if (this.currentTextboxOrButtonElements[index].rightMargin) {
            styles = Object.assign(styles, { right: this.currentTextboxOrButtonElements[index].rightMargin });
        }
        if (this.currentTextboxOrButtonElements[index].topMargin) {
            styles = Object.assign(styles, { top: this.currentTextboxOrButtonElements[index].topMargin });
        }
        if (this.currentTextboxOrButtonElements[index].bottomMargin) {
            styles = Object.assign(styles, { bottom: this.currentTextboxOrButtonElements[index].bottomMargin });
        }
        if (this.currentTextboxOrButtonElements[index].fontFamily) {
            styles = Object.assign(styles, { 'font-family': this.currentTextboxOrButtonElements[index].fontFamily });
        }
        if (this.currentTextboxOrButtonElements[index].fontStyle) {
            styles = Object.assign(styles, { 'font-weight': this.currentTextboxOrButtonElements[index].fontStyle });
        }
        if (this.currentTextboxOrButtonElements[index].fontSize) {
            styles = Object.assign(styles, { 'font-size': this.currentTextboxOrButtonElements[index].fontSize });
        }
        if (this.currentTextboxOrButtonElements[index].textAlignment) {
            styles = Object.assign(styles, { 'text-align': this.currentTextboxOrButtonElements[index].textAlignment });
        }
        if (this.currentTextboxOrButtonElements[index].textTransform) {
            styles = Object.assign(styles, { 'text-transform': this.currentTextboxOrButtonElements[index].textTransform });
        }
        if (this.currentTextboxOrButtonElements[index].fontColor) {
            styles = Object.assign(styles, { 'color': this.currentTextboxOrButtonElements[index].fontColor });
        }
        if (this.currentTextboxOrButtonElements[index].backgroundColor) {
            styles = Object.assign(styles, { 'background-color': this.currentTextboxOrButtonElements[index].backgroundColor });
        }
        if (this.currentTextboxOrButtonElements[index].width) {
            styles = Object.assign(styles, { 'width': this.currentTextboxOrButtonElements[index].width });
        }
        if (this.currentTextboxOrButtonElements[index].width) {
            styles = Object.assign(styles, { 'width': this.currentTextboxOrButtonElements[index].width });
        }
        if (this.currentTextboxOrButtonElements[index].topPadding) {
            styles = Object.assign(styles, { 'padding-top': this.currentTextboxOrButtonElements[index].topPadding });
        }
        if (this.currentTextboxOrButtonElements[index].bottomPadding) {
            styles = Object.assign(styles, { 'padding-bottom': this.currentTextboxOrButtonElements[index].bottomPadding });
        }
        if (this.currentTextboxOrButtonElements[index].borderColor) {
            if (this.currentTextboxOrButtonElements[index].border) {
                styles = Object.assign(styles, { 'border': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle + ' ' + this.currentTextboxOrButtonElements[index].borderColor });
            }
            else {
                if (this.currentTextboxOrButtonElements[index].borderLeft) {
                    styles = Object.assign(styles, { 'border-left': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle + ' ' + this.currentTextboxOrButtonElements[index].borderColor });
                }
                if (this.currentTextboxOrButtonElements[index].borderRight) {
                    styles = Object.assign(styles, { 'border-right': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle + ' ' + this.currentTextboxOrButtonElements[index].borderColor });
                }
                if (this.currentTextboxOrButtonElements[index].borderTop) {
                    styles = Object.assign(styles, { 'border-top': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle + ' ' + this.currentTextboxOrButtonElements[index].borderColor });
                }
                if (this.currentTextboxOrButtonElements[index].borderBottom) {
                    styles = Object.assign(styles, { 'border-bottom': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle + ' ' + this.currentTextboxOrButtonElements[index].borderColor });
                }
            }
        }
        else {
            if (this.currentTextboxOrButtonElements[index].border) {
                styles = Object.assign(styles, { 'border': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle });
            }
            else {
                if (this.currentTextboxOrButtonElements[index].borderLeft) {
                    styles = Object.assign(styles, { 'border-left': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle });
                }
                if (this.currentTextboxOrButtonElements[index].borderRight) {
                    styles = Object.assign(styles, { 'border-right': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle });
                }
                if (this.currentTextboxOrButtonElements[index].borderTop) {
                    styles = Object.assign(styles, { 'border-top': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle });
                }
                if (this.currentTextboxOrButtonElements[index].borderBottom) {
                    styles = Object.assign(styles, { 'border-bottom': this.currentTextboxOrButtonElements[index].cornerRadius + ' ' + this.currentTextboxOrButtonElements[index].borderStyle });
                }
            }
        }
        return styles;
    }
    getStylesLogo(index) {
        let styles = {};
        if (this.currentSlideElement.hasLogoImage) {
            if (this.currentSlideElement.logoPosition == 'Top-Left') {
                styles = Object.assign(styles, { top: "5px", left: "5px" });
            }
            if (this.currentSlideElement.logoPosition == 'Bottom-Left') {
                styles = Object.assign(styles, { bottom: "5px", left: "5px" });
            }
            if (this.currentSlideElement.logoPosition == 'Top-Right') {
                styles = Object.assign(styles, { top: "5px", right: "5px" });
            }
            if (this.currentSlideElement.logoPosition == 'Bottom-Right') {
                styles = Object.assign(styles, { bottom: "5px", right: "5px" });
            }
        }
        return styles;
    }
    setTextboxOrButtonValue(event, index) {
        console.log("blur");
        //this.textboxInProgress = false;
        if (event && event.relatedTarget && event.relatedTarget.id && this.designIds.indexOf(event.relatedTarget.id) > -1) {
            if (event.relatedTarget.id != 'designFontColorCheckBox' && event.relatedTarget.id != 'designBorderColorCheckBox' && event.relatedTarget.id != 'designBGColorCheckBox' && event.relatedTarget.id != 'increaseFontSize' && event.relatedTarget.id != 'decreaseFontSize') {
                event.relatedTarget.click();
            }
            // setTimeout(() => {
            //   this.focusElement(event.target.id);
            // }, 5000);
            //document.getElementById(event.target.id).focus();
            if (event.relatedTarget.id == 'designFontSize' || event.relatedTarget.id == 'designFontColor' || event.relatedTarget.id == 'designBorderColor' || event.relatedTarget.id == 'designBGColor') {
                setTimeout(() => {
                    event.relatedTarget.click();
                }, 200);
            }
            else {
                document.getElementById(event.target.id).focus();
                this.textboxInProgress = true;
            }
            this.fontFamily = cloneDeep(this.currentTextboxOrButtonElements[index].fontFamily);
            this.fontSize = cloneDeep(this.currentTextboxOrButtonElements[index].fontSize);
            this.fontStyle = cloneDeep(this.currentTextboxOrButtonElements[index].fontStyle);
            this.fontColor = cloneDeep(this.currentTextboxOrButtonElements[index].fontColor);
            this.backgroundColor = cloneDeep(this.currentTextboxOrButtonElements[index].backgroundColor);
            this.borderColor = cloneDeep(this.currentTextboxOrButtonElements[index].borderColor);
            this.borderStyle = cloneDeep(this.currentTextboxOrButtonElements[index].borderStyle);
            this.cornerRadius = cloneDeep(this.currentTextboxOrButtonElements[index].cornerRadius);
            this.width = cloneDeep((this.currentTextboxOrButtonElements[index].width) + ''.replace('%', ''));
            this.topPadding = cloneDeep((this.currentTextboxOrButtonElements[index].topPadding) + ''.replace('%', ''));
            this.bottomPadding = cloneDeep((this.currentTextboxOrButtonElements[index].bottomPadding) + ''.replace('%', ''));
        }
        else if (event && event.relatedTarget && event.relatedTarget.id) {
            this.currentTextboxOrButtonElements[index].text = event.target.innerText;
            //this.currentTextboxOrButtonElements[index].text = this.htmlToPlaintext(event.target.innerText);
            //console.log(this.getWordCountInSlide(this.webStory.elements[this.currentSlideIndex]));
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            console.log(this.currentSlideWords);
            this.currentTextboxOrButtonElementIndex = null;
            this.fontFamily = null;
            this.fontSize = null;
            this.fontStyle = null;
            this.fontColor = null;
            this.backgroundColor = null;
            this.borderColor = null;
            this.borderStyle = null;
            this.cornerRadius = null;
            this.width = null;
            this.topPadding = null;
            this.bottomPadding = null;
            if (event.relatedTarget.id == 'addTextbox' || ((event.relatedTarget.id + '').indexOf('ButtonLink') > 0) || ((event.relatedTarget.id + '').indexOf('CloseAction') > 0)
                || ((event.relatedTarget.id + '').indexOf('CopyAction') > 0) || ((event.relatedTarget.id + '').indexOf('Refresh') > 0)
                || (event.relatedTarget.id == 'moveLeftSlide') || (event.relatedTarget.id == 'moveRightSlide')
                || (event.relatedTarget.id == 'moveLeftSlideImg') || (event.relatedTarget.id == 'moveRightSlideImg')
                || (event.relatedTarget.id == 'addLeftSlide') || (event.relatedTarget.id == 'addRightSlide')
                || (event.relatedTarget.id == 'deleteSlide') || (event.relatedTarget.id == 'copySlide')
                || (event.relatedTarget.id == 'useTemplate') || (event.relatedTarget.id == 'fileStory')
                || (event.relatedTarget.id == 'finishedEditing') || (event.relatedTarget.id == 'scheduleToPublish')
                || ((event.relatedTarget.id + '').indexOf('activeSlide') > 0)) {
                this.updateSlide(res => {
                    this.textboxInProgress = false;
                    event.relatedTarget.click();
                });
            }
            else {
                this.updateSlide(res => { });
                this.textboxInProgress = false;
                event.relatedTarget.click();
            }
        }
        else {
            this.currentTextboxOrButtonElements[index].text = event.target.innerText;
            //this.currentTextboxOrButtonElements[index].text = this.htmlToPlaintext(event.target.innerText);
            //console.log(this.getWordCountInSlide(this.webStory.elements[this.currentSlideIndex]));
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            console.log(this.currentSlideWords);
            this.currentTextboxOrButtonElementIndex = null;
            this.fontFamily = null;
            this.fontSize = null;
            this.fontStyle = null;
            this.fontColor = null;
            this.backgroundColor = null;
            this.borderColor = null;
            this.borderStyle = null;
            this.cornerRadius = null;
            this.width = null;
            this.topPadding = null;
            this.bottomPadding = null;
            this.updateSlide(res => { });
            this.textboxInProgress = false;
        }
        //this.buttonUrl = null;
    }
    setTextboxOrButtonIndex(event, index) {
        console.log('focus');
        this.textboxInProgress = true;
        this.currentTextboxOrButtonElementIndex = index;
        //this.buttonUrl = this.currentTextboxOrButtonElements[index].url;
        this.fontFamily = cloneDeep(this.currentTextboxOrButtonElements[index].fontFamily);
        this.fontSize = cloneDeep(this.currentTextboxOrButtonElements[index].fontSize);
        this.fontStyle = cloneDeep(this.currentTextboxOrButtonElements[index].fontStyle);
        this.fontColor = cloneDeep(this.currentTextboxOrButtonElements[index].fontColor);
        this.backgroundColor = cloneDeep(this.currentTextboxOrButtonElements[index].backgroundColor);
        this.borderColor = cloneDeep(this.currentTextboxOrButtonElements[index].borderColor);
        this.borderStyle = cloneDeep(this.currentTextboxOrButtonElements[index].borderStyle);
        this.cornerRadius = cloneDeep(this.currentTextboxOrButtonElements[index].cornerRadius);
        this.width = cloneDeep((this.currentTextboxOrButtonElements[index].width) + ''.replace('%', ''));
        this.topPadding = cloneDeep((this.currentTextboxOrButtonElements[index].topPadding) + ''.replace('%', ''));
        this.bottomPadding = cloneDeep((this.currentTextboxOrButtonElements[index].bottomPadding) + ''.replace('%', ''));
    }
    focusTextboxOrButton(event) {
        console.log(event);
        document.getElementById(this.currentSlideElement.id + 'textboxOrButton' + this.currentTextboxOrButtonElementIndex).focus();
        this.textboxInProgress = true;
    }
    removeTextboxOrButton(index) {
        this.currentTextboxOrButtonElementIndex = null;
        this.currentTextboxOrButtonElements.splice(index, 1);
        this.currentSlideWords = this.getWordCountOfCurrentsSlide();
        console.log(this.currentSlideWords);
        this.updateSlide(res => { });
    }
    setLeftMargin(left, right) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = left;
        if (right) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left = true;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = right;
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.left = left;
        if (right) {
            elem.style.right = right;
        }
    }
    setRightMargin(right, left) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = right;
        if (left) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right = true;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = left;
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.right = right;
        if (left) {
            elem.style.left = left;
        }
    }
    setTopMargin(top, bottom) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = top;
        if (bottom) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top = true;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = bottom;
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.top = top;
        if (bottom) {
            elem.style.bottom = bottom;
        }
    }
    setBottomMargin(bottom, top) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom = true;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top = false;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = bottom;
        if (top) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = top;
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.bottom = bottom;
        if (top) {
            elem.style.top = top;
        }
    }
    setTopBottomCenterMargin() {
        let containerElement = document.getElementById(this.currentSlideElement.id + 'li');
        let containerHeight = containerElement.offsetHeight;
        let blockElement = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        let blockHeight = blockElement.offsetHeight;
        let diff = (blockHeight / containerHeight) * 100;
        let value = (100 - diff) / 2;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = true;
        if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = value + '%';
        }
        else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = value + '%';
        }
        else {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin != 'auto') {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin != 'auto') {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = value + '%';
            }
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.bottom = this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin;
        elem.style.top = this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin;
    }
    setLeftRightCenterMargin() {
        let containerElement = document.getElementById(this.currentSlideElement.id + 'li');
        let containerWidth = containerElement.offsetWidth;
        let blockElement = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        let blockWidth = blockElement.offsetWidth;
        let diff = (blockWidth / containerWidth) * 100;
        let value = (100 - diff) / 2;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftRightCenter = true;
        if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = value + '%';
        }
        else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right) {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = value + '%';
        }
        else {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin != 'auto') {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin != 'auto') {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = value + '%';
            }
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
        const elem = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        elem.style.left = this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin;
        elem.style.right = this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin;
    }
    changeMargin(position, value) {
        let containerElement = document.getElementById(this.currentSlideElement.id + 'li');
        let containerHeight = containerElement.offsetHeight;
        let containerWidth = containerElement.offsetWidth;
        let blockElement = document.getElementById(this.currentSlideElement.id + 'textboxOrButtonDiv' + this.currentTextboxOrButtonElementIndex);
        let blockHeight = blockElement.offsetHeight;
        let blockWidth = blockElement.offsetWidth;
        if (position == 'top') {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom) {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottom = false;
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin != 'auto') {
                let diff = (blockHeight / containerHeight) * 100;
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin.replace('%', ''));
                if ((currentMargin + value + diff) < 100) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = (currentMargin + value) + '%';
                }
                else {
                    this.setTopMargin('0%', 'auto');
                }
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin != 'auto') {
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin.replace('%', ''));
                if (currentMargin > value) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = (currentMargin - value) + '%';
                }
                else {
                    this.setTopMargin('0%', 'auto');
                }
            }
        }
        if (position == 'bottom') {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top) {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].top = false;
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin != 'auto') {
                let diff = (blockHeight / containerHeight) * 100;
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin.replace('%', ''));
                if ((currentMargin + value + diff) < 100) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topMargin = (currentMargin + value) + '%';
                }
                else {
                    this.setBottomMargin('0%', 'auto');
                }
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin != 'auto') {
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin.replace('%', ''));
                if (currentMargin > value) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomMargin = (currentMargin - value) + '%';
                }
                else {
                    this.setBottomMargin('0%', 'auto');
                }
            }
        }
        if (position == 'left') {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right) {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].right = false;
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin != 'auto') {
                let diff = (blockWidth / containerWidth) * 100;
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin.replace('%', ''));
                if ((currentMargin + value + diff) < 100) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = (currentMargin + value) + '%';
                }
                else {
                    this.setLeftMargin('0%', 'auto');
                }
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin != 'auto') {
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin.replace('%', ''));
                if (currentMargin > value) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = (currentMargin - value) + '%';
                }
                else {
                    this.setLeftMargin('0%', 'auto');
                }
            }
        }
        if (position == 'right') {
            if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left) {
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].left = false;
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = value + '%';
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin != 'auto') {
                let diff = (blockWidth / containerWidth) * 100;
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin.replace('%', ''));
                if ((currentMargin + value + diff) < 100) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftMargin = (currentMargin + value) + '%';
                }
                else {
                    this.setRightMargin('0%', 'auto');
                }
            }
            else if (this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin != 'auto') {
                let currentMargin = +(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin.replace('%', ''));
                if (currentMargin > value) {
                    this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].rightMargin = (currentMargin - value) + '%';
                }
                else {
                    this.setRightMargin('0%', 'auto');
                }
            }
        }
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    setLeftAlignment(left, index) {
        this.currentTextboxOrButtonElements[index].leftAlignment = left;
    }
    setRightAlignment(right, index) {
        this.currentTextboxOrButtonElements[index].rightAlignment = right;
    }
    setTopAlignment(top, index) {
        this.currentTextboxOrButtonElements[index].topAlignment = top;
    }
    setBottomAlignment(bottom, index) {
        this.currentTextboxOrButtonElements[index].bottomAlignment = bottom;
    }
    setTextAlignment(textAlignment) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textAlignment = textAlignment;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    setFontFamily() {
        if (this.fontFamily !== undefined && this.fontFamily != null && this.fontFamily != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].fontFamily = cloneDeep(this.fontFamily);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftRightCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setFontSize() {
        if (this.fontSize !== undefined && this.fontSize != null && this.fontSize != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].fontSize = cloneDeep(this.fontSize);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftRightCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setFontStyle() {
        if (this.fontStyle !== undefined && this.fontStyle != null && this.fontStyle != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].fontStyle = cloneDeep(this.fontStyle);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftRightCenter = false;
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setFontColor() {
        if (this.fontColor !== undefined && this.fontColor != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].fontColor = cloneDeep(this.fontColor);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setBorderStyle() {
        if (this.borderStyle !== undefined && this.borderStyle != null && this.borderStyle != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderStyle = cloneDeep(this.borderStyle);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setBorderColor() {
        if (this.borderColor !== undefined && this.borderColor != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderColor = cloneDeep(this.borderColor);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setBackgroundColor() {
        if (this.backgroundColor !== undefined && this.backgroundColor != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].backgroundColor = cloneDeep(this.backgroundColor);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setTextTransform(textTransform) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textTransform = textTransform;
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    changeBorderLeft() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderLeft = !(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderLeft);
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    changeBorderTop() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderTop = !(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderTop);
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    changeBorderRight() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderRight = !(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderRight);
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    changeBorderBottom() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderBottom = !(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].borderBottom);
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    changeBorder() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].border = !(this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].border);
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        this.updateSlide(res => { });
    }
    setCornerRadius() {
        if (this.cornerRadius !== undefined && this.cornerRadius != null && this.cornerRadius != '') {
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].cornerRadius = cloneDeep(this.cornerRadius);
            this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElementIndex));
        }
        this.updateSlide(res => { });
    }
    setTextAnimation() {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].textAnimation = this.textAnimation;
    }
    setURL(url, index) {
        this.currentTextboxOrButtonElements[index].url = url;
    }
    setType(type, index) {
        this.currentTextboxOrButtonElements[index].type = type;
    }
    setUrl(url) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].url = url;
        this.updateSlide(res => { });
    }
    cancelCropping(event, index) {
        this.showCropper.splice(index, 1);
        this.cropperImageUrl = {
            url: null,
            data: null,
            blobData: null
        };
    }
    cropImage(event, index, res) {
        this.uploadImageInProgress = false;
        const reader = new FileReader();
        const a = reader.readAsDataURL(event.target.files[index]);
        reader.onload = (e) => {
            this.cropperImageUrl.data = e.target.result;
            this.cropperImageUrl.url = res['images']['original'];
            this.showCropper.push({ crop: true, cropperImageUrl: cloneDeep(this.cropperImageUrl) });
        };
    }
    cropImageFromLibrary(fileUrl, res, id) {
        this.uploadImageInProgress = false;
        const reader = new FileReader();
        fileUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + fileUrl;
        this.sharedService.getImage(fileUrl).subscribe(file => {
            const a = reader.readAsDataURL(file);
            reader.onload = (e) => {
                this.cropperImageUrl.data = e.target.result;
                this.cropperImageUrl.url = res['image']['images']['original'];
                this.showCropper.push({ crop: true, cropperImageUrl: cloneDeep(this.cropperImageUrl), parentId: id });
            };
        });
    }
    finishCropping(event, index) {
        this.uploadImageInProgress = true;
        const requests = event.cropRequests;
        const verticalFlag = event.verticalFlag;
        const differentLeadFlag = event.differentImage;
        const parentElementId = event.parentId;
        this.showCropper[index]['crop'] = false;
        this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
            if (!data.hasOwnProperty('error')) {
                const { ampFlag, imagemap } = data;
                this.uploadImageInProgress = false;
                if (this.imageType != 'coverImage' && index == 0 && !this.tempCurrentSlide.hasSlideImage && !this.tempCurrentSlide.hasSlideVideo) {
                    let lastSlideIndex = cloneDeep(this.currentSlideIndex);
                    this.currentSlideElement = cloneDeep(this.tempCurrentSlide);
                    this.currentSlideIndex = cloneDeep(this.tempCurrentSlideIndex);
                    this.currentSlideWords = this.getWordCountOfCurrentsSlide();
                    this.tempCurrentSlide = {};
                    this.tempCurrentSlideIndex = null;
                    this.deleteVideo();
                    this.currentSlideElement.imageAmpValidated = ampFlag;
                    this.currentSlideElement.image.verticalImage = verticalFlag;
                    this.currentSlideElement.image.images = imagemap;
                    this.currentSlideElement.hasSlideImage = true;
                    this.currentSlideElement.image.caption = imagemap['original'].slice(imagemap['original'].lastIndexOf('/') + 1, imagemap['original'].lastIndexOf('_'));
                    if (parentElementId && parentElementId > 0) {
                        this.currentSlideElement['parentElementId'] = parentElementId;
                    }
                    //this.updateSlide(res => {this.changeCurrentSlide(this.slideIds.length-1)});
                    this.updateSlide(res => { this.changeCurrentSlide(cloneDeep(this.lastImageAddedIndex)); });
                }
                else if (this.imageType != 'coverImage') {
                    this.currentSlideElement = JSON.parse(JSON.stringify(StaticDataService.defaultSlideData));
                    this.currentSlideElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
                    this.currentSlideIndex = this.currentSlideIndex + 1;
                    this.lastImageAddedIndex = cloneDeep(this.currentSlideIndex);
                    this.currentSlideElement.type = 'slide';
                    this.currentSlideElement.imageAmpValidated = ampFlag;
                    this.currentSlideElement.image.verticalImage = verticalFlag;
                    this.currentSlideElement.image.images = imagemap;
                    this.currentSlideElement.hasSlideImage = true;
                    this.currentSlideElement.image.caption = imagemap['original'].slice(imagemap['original'].lastIndexOf('/') + 1, imagemap['original'].lastIndexOf('_'));
                    if (parentElementId && parentElementId > 0) {
                        this.currentSlideElement['parentElementId'] = parentElementId;
                    }
                    this.useLogo("Top-Left");
                    this.saveNewSlide("right");
                }
                else if (this.imageType == 'coverImage') {
                    //this.webStory.coverImageUrl = imagemap['original'];
                    // this.webStory['imageAmpValidated'] = ampFlag;
                    // this.webStory['leadMedia']['image']['verticalImage']=verticalFlag;
                    // this.webStory['leadMedia']['image']['images']=imagemap;
                    // this.webStory['leadMedia']['image']['caption'] = imagemap['original'].slice(imagemap['original'].lastIndexOf('/'),imagemap['original'].lastIndexOf('_'));
                    // this.webStory.imageAmpValidated = ampFlag;
                    // let leadMedia = {'image':{'verticalImage':'','images':{},'caption':''}};
                    // leadMedia.image.verticalImage = verticalFlag;
                    // leadMedia.image.images = imagemap;
                    // leadMedia.image.caption = imagemap['original'].slice(imagemap['original'].lastIndexOf('/'),imagemap['original'].lastIndexOf('_'));
                    // this.webStory.leadMedia = leadMedia;
                    // this.updateStoryData.emit(this.webStory);
                    // this.snotify.success('Cover image uploaded successfully', '', this.sharedService.getConfig(false));
                    this.createUploadedCoverImageElement(ampFlag, verticalFlag, imagemap, parentElementId);
                }
            }
            else {
                this.uploadImageInProgress = false;
                this.snotify.error('Failed to crop image ', '', this.sharedService.getConfig(false));
            }
        });
    }
    finishCropping1(event, index) {
        const template = JSON.parse(localStorage.getItem('webStoryTemplate'));
        this.uploadImageInProgress = true;
        const requests = event.cropRequests;
        const verticalFlag = event.verticalFlag;
        const differentLeadFlag = event.differentImage;
        this.showCropper[index]['crop'] = false;
        this.sharedService.croppingSequence(requests, differentLeadFlag, data => {
            if (!data.hasOwnProperty('error')) {
                const { ampFlag, imagemap } = data;
                this.uploadImageInProgress = false;
                this.AiImageData.push(imagemap);
                console.log(this.AiImageData);
                console.log(this.aiGalleryData.story[0].listImages);
                if (this.AiImageData.length === this.elements.length + 1) {
                    const rearrangedAiImageData = [];
                    for (const galleryImage of this.aiGalleryData.story[0].listImages) {
                        const correspondingImage = this.AiImageData.find((imageData) => imageData.original.includes(galleryImage.src.slice(0, -5)));
                        if (correspondingImage) {
                            rearrangedAiImageData.push(correspondingImage);
                        }
                    }
                    console.log(rearrangedAiImageData);
                    this.imageData = rearrangedAiImageData;
                    this.webStory.coverImageUrl = this.imageData[0]['original'];
                    this.webStory.headline = this.aiGalleryData.headline;
                    this.webStory.metadata.aiContentType = "AI Gallery Web Story";
                    this.webStoryHeadline.emit(this.aiGalleryData.headline);
                    this.webStorySummary.emit(this.aiGalleryData.headline);
                    this.webStory.summary = this.aiGalleryData.headline;
                    this.webStory.mobileHeadline = this.aiGalleryData.headline;
                    this.webStory.urlHeadline = this.aiGalleryData.headline;
                    this.webStory.metadata.authors.push('Livemint');
                    this.restService.http_post(this.config.get('product').baseUrl +
                        this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.all_element_api), this.elements, (res) => {
                        if (res && (res !== null) && !res.hasOwnProperty('error')) {
                            let newElements = [];
                            let i = 1;
                            for (let element of res) {
                                element.id = null;
                                element.logoUrl = this.logoUrl;
                                element.domainId = this.domainConfig['domainId'];
                                element.image.images = this.imageData[i];
                                element.hasSlideImage = true;
                                element.webStorySlide[0].text = this.aiGalleryData.story[0].listImages[i].title;
                                element.creditInfo = this.aiGalleryData.story[0].listImages[i].credit;
                                if (element.webStorySlide[1]) {
                                    element.webStorySlide[1].text = this.aiGalleryData.story[0].listImages[i].description;
                                }
                                else {
                                    const newSlide = Object.assign({}, element.webStorySlide[0], { text: this.aiGalleryData.story[0].listImages[i].description // Update the text property
                                     });
                                    element.webStorySlide.push(newSlide);
                                }
                                i++;
                                if (element && element.webStorySlide != null && element.webStorySlide.length > 0) {
                                    element.webStorySlide.forEach((ele) => {
                                        if (ele.fontSize.indexOf('px') > -1) {
                                            ele.fontSize = ((+(ele.fontSize.replace('px', ''))) * 0.0625) + 'em';
                                            if (ele.textboxCSS != null || ele.textboxCSS == undefined) {
                                                ele.textboxCSS['font-size'] = ele.fontSize;
                                            }
                                        }
                                    });
                                }
                                newElements.push(element);
                            }
                            this.imageType = 'coverImage';
                            let imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + this.imageData[0]['original'];
                            this.sharedService.getImage(imageUrl).subscribe(file => {
                                const reader = new FileReader();
                                const a = reader.readAsDataURL(file);
                                reader.onload = (e) => {
                                    this.cropperImageUrl.data = e.target.result;
                                    this.cropperImageUrl.url = imageUrl;
                                    this.showCropper.push({ crop: true, cropperImageUrl: cloneDeep(this.cropperImageUrl) });
                                };
                            });
                            this.slideIds = [];
                            this.saveMultipleSlides(newElements, template);
                            this.isAIimge = false;
                            this.elements = [];
                            this.AiImageData = [];
                            this.AIindex;
                        }
                        else {
                            this.snotify.error('Failed to fetch template data', '', this.sharedService.getConfig(false));
                        }
                    });
                }
            }
            else {
                this.uploadImageInProgress = false;
                this.snotify.error('Failed to crop image ', '', this.sharedService.getConfig(false));
            }
        });
    }
    onFileChange(event, imageType) {
        this.imageType = imageType;
        this.clsoeImage();
        this.closeCoverImage();
        this.showCropper = [];
        if (event.target.files && event.target.files.length > 0) {
            // this.selectedFile = <File>event.target.files[0];
            this.tempCurrentSlide = cloneDeep(this.currentSlideElement);
            this.tempCurrentSlideIndex = cloneDeep(this.currentSlideIndex);
            this.lastImageAddedIndex = cloneDeep(this.currentSlideIndex);
            for (let i = 0; i < event.target.files.length; i++) {
                this.selectedFile = event.target.files[i];
                const fd = new FormData();
                if ((this.selectedFile.size / 1000000) <= 11) {
                    fd.append('file', this.selectedFile, this.selectedFile.name);
                    fd.append('removeLowQualityRestriction', 'true');
                    this.uploadImageInProgress = true;
                    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
                        subscribe(res => {
                        this.uploadImageInProgress = false;
                        // let imagePath = res['images'].original;
                        // this.deleteVideo();
                        // this.currentSlideElement.image.images['original'] = imagePath.replace(/"/gi, '');
                        // this.currentSlideElement.hasSlideImage = true;
                        // this.currentSlideElement.image.caption = this.selectedFile.name.slice(0,this.selectedFile.name.lastIndexOf('.'));
                        this.cropImage(event, i, res);
                        // this.updateSlide(res => {});
                    }, err => {
                        if (err.error.errorMessage && err.error.errorMessage.indexOf('low') != -1) {
                            this.snotify.error('Image is of low quality, Please upload a new image( > 100KB)', '', this.sharedService.getConfig(false));
                        }
                        else {
                            console.log(err.error.errorMessage);
                            this.snotify.error(err.error.errorMessage, '', this.sharedService.getConfig(false));
                        }
                        this.uploadImageInProgress = false;
                    });
                }
                else {
                    this.selectedFile = null;
                    this.uploadImageInProgress = false;
                    this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
                }
            }
        }
    }
    onVideoFileChange(event) {
        this.closeVideo();
        const fd = new FormData();
        this.selectedFile = event.target.files[0];
        if (event.target.files && event.target.files.length > 0) {
            if ((this.selectedFile.size / 1000000) <= 11) {
                fd.append('file', this.selectedFile, this.selectedFile.name);
                this.uploadImageInProgress = true;
                this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').videoUploadEndPoint, fd).subscribe(res => {
                    this.uploadImageInProgress = false;
                    let videoPath = res['url'];
                    this.deleteBackgroundImage();
                    this.currentSlideElement.video.url = videoPath.replace(/"/gi, '');
                    this.currentSlideElement.hasSlideVideo = true;
                    //this.currentSlideElement.video.image = {'caption':this.selectedFile.name.slice(0,this.selectedFile.name.lastIndexOf('.'))};
                    this.updateSlide(res => { });
                }, err => {
                    this.uploadImageInProgress = false;
                });
            }
            else {
                this.selectedFile = null;
                this.uploadImageInProgress = false;
                this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
            }
        }
    }
    showGallery(imageType) {
        this.imageType = imageType;
        this.clsoeImage();
        this.closeCoverImage();
        this.isLightbox = true;
        this.isPhotopopup = true;
        this.sharedService.overflowhidden();
    }
    disableshowGallery() {
        this.isLightbox = false;
        this.isPhotopopup = false;
        this.showAllStory = true;
        this.showMyWorkSpace = false;
        this.showPixabay = false;
        this.showNonWeb = false;
        this.sharedService.overflowauto();
    }
    uploadWireImage(imagePath, imageType) {
        this.imageType = imageType;
        this.showCropper = [];
        this.tempCurrentSlide = cloneDeep(this.currentSlideElement);
        this.tempCurrentSlideIndex = cloneDeep(this.currentSlideIndex);
        this.lastImageAddedIndex = cloneDeep(this.currentSlideIndex);
        const fd = new FormData();
        fd.append('file', imagePath);
        this.uploadImageInProgress = true;
        this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
            subscribe(res => {
            this.uploadImageInProgress = false;
            let res2 = { 'image': { 'images': { 'original': res['images']['original'] } } };
            this.cropImageFromLibrary(res2.image.images['original'], res, null);
            //this.cropImage(event, i, res);
        }, err => {
            this.uploadImageInProgress = false;
        });
    }
    cropWireImage(fileUrl, res) {
        this.uploadImageInProgress = true;
        const reader = new FileReader();
        fileUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + fileUrl;
        this.sharedService.getImage(fileUrl).subscribe(file => {
            const a = reader.readAsDataURL(file);
            reader.onload = (e) => {
                this.cropperImageUrl.data = e.target.result;
                this.cropperImageUrl.url = res['image']['images']['original'];
                this.showCropper.push({ crop: true, cropperImageUrl: cloneDeep(this.cropperImageUrl) });
                this.uploadImageInProgress = false;
            };
            reader.onloadend = (e) => {
                this.uploadImageInProgress = false;
            };
        });
    }
    getMediaId(ev, type) {
        this.showCropper = [];
        this.tempCurrentSlide = cloneDeep(this.currentSlideElement);
        this.tempCurrentSlideIndex = cloneDeep(this.currentSlideIndex);
        this.lastImageAddedIndex = cloneDeep(this.currentSlideIndex);
        if (ev && ev.length > 0) {
            this.disableshowGallery();
            for (let i = 0; i < ev.length; i++) {
                if (type == 'wire' || type === 'pixabayListing') {
                    let res = { 'image': { 'images': { 'original': ev[i].id } } };
                    this.cropWireImage(res.image.images['original'], res);
                    //this.cropImageFromLibrary(res.image.images['original'],res);
                    //this.uploadWireImage(ev[i].imageUrl,'slideImage');
                }
                else {
                    this.createDuplicateImageChild(ev[i].id);
                }
            }
        }
        else {
            this.disableshowGallery();
            this.snotify.error('Failed to get image id', '', this.sharedService.getConfig(false));
        }
    }
    getLeadMediaId(ev, type) {
        this.showCropper = [];
        if (ev) {
            this.disableshowGallery();
            if (type == 'wire' || type == 'pixabayListing') {
                let res = { 'image': { 'images': { 'original': ev.id } } };
                this.cropWireImage(res.image.images['original'], res);
                //this.cropImageFromLibrary(res.image.images['original'],res);
            }
            else {
                this.createDuplicateImageChild(ev.id);
            }
            //this.createDuplicateImageChild(ev.id);
        }
        else {
            this.disableshowGallery();
            this.snotify.error('Failed to get image id', '', this.sharedService.getConfig(false));
        }
    }
    getVideoElementId(ev) {
        if (ev && ev.id) {
            this.createDuplicateVideoChild(ev.id);
        }
        else {
            this.disableshowVideoGallery();
            this.snotify.error('Failed to get video id', '', this.sharedService.getConfig(false));
        }
    }
    createDuplicateImageChild(id) {
        this.restService.http_get(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
            + '/' + id)
            .subscribe(result => {
            if (result) {
                this.cropImageFromLibrary(result.image.images['original'], result, id);
                // this.deleteVideo();
                // this.currentSlideElement.image.images['original'] = result.image.images['original']
                // this.currentSlideElement.hasSlideImage = true;
                // this.updateSlide(res => {});
                // this.disableshowGallery();
            }
        }, err => {
            this.disableshowGallery();
            this.snotify.error('Failed to get image from id', '', this.sharedService.getConfig(false));
        });
    }
    createUploadedCoverImageElement(ampFlag, verticalFlag, imagemap, parentElementId) {
        const ImageCardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
        ImageCardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        ImageCardData.id = null;
        ImageCardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        ImageCardData.imageAmpValidated = ampFlag;
        ImageCardData.image.verticalImage = verticalFlag;
        ImageCardData.image.images = imagemap;
        ImageCardData['removeLowQualityRestriction'] = true;
        ImageCardData.image.caption = imagemap['original'].slice(imagemap['original'].lastIndexOf('/') + 1, imagemap['original'].lastIndexOf('_'));
        if (parentElementId && parentElementId > 0) {
            ImageCardData['parentElementId'] = parentElementId;
        }
        this.restService.http_post(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'), ImageCardData, image => {
            if (image.hasOwnProperty('error')) {
                // this.webStory.leadMedia.elements = [];
                // this.webStory.imageAmpValidated = false;
                this.snotify.clear();
                this.updateStoryData.emit(this.webStory);
                this.snotify.error('Failed to upload Cover Image.', '', this.sharedService.getConfig(false));
            }
            else if (image && image.id) {
                let leadMedia = { 'mediaType': 'image', 'elements': [image.id] };
                if (image.image) {
                    leadMedia['image'] = cloneDeep(image.image);
                }
                this.webStory.leadMedia = cloneDeep(leadMedia);
                this.webStory.imageAmpValidated = ampFlag;
                this.webStory.coverImageUrl = imagemap['900x1600'] ? imagemap['900x1600'] : imagemap['original'];
                this.updateStoryData.emit(this.webStory);
                this.snotify.success('Cover image uploaded successfully', '', this.sharedService.getConfig(false));
            }
            else {
                this.snotify.clear();
                this.updateStoryData.emit(this.webStory);
                this.snotify.error('Failed to upload Cover Image.', '', this.sharedService.getConfig(false));
            }
        });
    }
    createDuplicateVideoChild(id) {
        this.restService.http_get(this.config.get('product').baseUrl
            + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
            + '/' + id)
            .subscribe(result => {
            if (result) {
                this.deleteBackgroundImage();
                this.currentSlideElement.video.url = result.video.url;
                this.currentSlideElement.hasSlideVideo = true;
                if (result.video.image && result.video.image.caption) {
                    this.currentSlideElement.video.image = { 'caption': result.video.image.caption };
                }
                this.updateSlide(res => { });
                this.disableshowVideoGallery();
            }
        }, err => {
            this.disableshowVideoGallery();
            this.snotify.error('Failed to get video from id', '', this.sharedService.getConfig(false));
        });
    }
    showVideoGallery() {
        this.closeVideo();
        this.isLightboxVideo = true;
        this.sharedService.overflowhidden();
    }
    disableshowVideoGallery() {
        this.isLightboxVideo = false;
        this.videoOptions = false;
        this.sharedService.overflowauto();
    }
    useLogo(logoPosition) {
        this.currentSlideElement.hasLogoImage = true;
        this.currentSlideElement.logoUrl = this.logoUrl;
        this.currentSlideElement.logoPosition = logoPosition;
    }
    removeLogo() {
        this.currentSlideElement.hasLogoImage = false;
        this.currentSlideElement.logoUrl = null;
        this.currentSlideElement.logoPosition = null;
        this.updateSlide(res => { });
    }
    setLogoPosition(logoPosition) {
        this.currentSlideElement.logoPosition = logoPosition;
    }
    setWebStoryAsTemplate() {
        if (this.webStory.isWebStoryTemplate) {
            this.webStory.isWebStoryTemplate = false;
        }
        else {
            this.webStory.isWebStoryTemplate = true;
        }
    }
    lightBoxCoverImage() {
        this.isLightboxCoverImage = true;
    }
    closeLightBoxCoverImage() {
        this.isLightboxCoverImage = false;
    }
    uploadCoverImage(event) {
        this.closeCoverImage();
        const fd = new FormData();
        this.selectedFile = event.target.files[0];
        if (event.target.files && event.target.files.length > 0) {
            if ((this.selectedFile.size / 1000000) <= 11) {
                fd.append('file', this.selectedFile, this.selectedFile.name);
                this.uploadImageInProgress = true;
                this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
                    subscribe(res => {
                    this.uploadImageInProgress = false;
                    let imagePath = res['images'].original;
                    this.webStory.coverImageUrl = imagePath.replace(/"/gi, '');
                    this.updateStoryData.emit(this.webStory);
                    this.snotify.success('Cover image uploaded successfully', '', this.sharedService.getConfig(false));
                }, err => {
                    this.snotify.error('Failed to upload cover image', '', this.sharedService.getConfig(false));
                    this.uploadImageInProgress = false;
                });
            }
            else {
                this.selectedFile = null;
                this.uploadImageInProgress = false;
                this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
            }
        }
    }
    removeCoverImage() {
        this.webStory.coverImageUrl = null;
    }
    useTemplateWebStory(template) {
        if (!this.textboxInProgress) {
            const _a = this.sharedService.getConfig(true), { timeout, closeOnClick } = _a, config = tslib_1.__rest(_a, ["timeout", "closeOnClick"]); // Omit props what i don't need
            this.snotify.confirm('Do you want to use this template?', '', Object.assign({}, config, { buttons: [
                    {
                        text: 'Yes', action: (toast) => {
                            this.snotify.remove(toast.id);
                            let newWebStory = cloneDeep(template);
                            if (newWebStory && newWebStory.elements && newWebStory.elements.length > 0) {
                                let elements = newWebStory.elements;
                                this.restService.http_post(this.config.get('product').baseUrl
                                    + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.all_element_api), elements, res => {
                                    if (res && (res !== null) && !res.hasOwnProperty('error')) {
                                        let newElements = [];
                                        for (let element of res) {
                                            element.id = null;
                                            element.logoUrl = this.logoUrl;
                                            element.domainId = this.domainConfig['domainId'];
                                            if (element && element.webStorySlide != null && element.webStorySlide.length > 0) {
                                                element.webStorySlide.forEach(ele => {
                                                    if (ele.fontSize.indexOf("px") > -1) {
                                                        ele.fontSize = ((+(ele.fontSize.replace("px", ""))) * 0.0625) + "em";
                                                        if (ele.textboxCSS != null || ele.textboxCSS == undefined) {
                                                            ele.textboxCSS["font-size"] = ele.fontSize;
                                                        }
                                                    }
                                                });
                                            }
                                            newElements.push(element);
                                        }
                                        this.slideIds = [];
                                        this.saveMultipleSlides(newElements, template);
                                    }
                                    else {
                                        this.snotify.error('Failed to fetch template data', '', this.sharedService.getConfig(false));
                                    }
                                });
                            }
                            this.googleAnalytics("Skippable Alerts", 'Do you want to use this template?', sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'Yes', null);
                        }, bold: false
                    },
                    {
                        text: 'No', action: (toast) => {
                            this.snotify.warning('Choose YES to select Templete!', '', this.sharedService.getConfig(false));
                            this.snotify.remove(toast.id);
                            this.googleAnalytics("Skippable Alerts", 'Do you want to use this template?', sessionStorage.getItem(StaticDataService.tenantName) + ' ' + 'No', null);
                        }
                    }
                ] }));
        }
    }
    chooseTemplateforAI(template) {
        this.snotify.info('Picking AI Template and uploading Image Please Wait...', '', Object.assign({}, this.sharedService.getConfig(false), { timeout: 10000 }));
        let newWebStory = cloneDeep(template);
        if (newWebStory && newWebStory.elements && newWebStory.elements.length > 0) {
            this.elements = newWebStory.elements;
            if (this.aiGalleryData.story[0].listImages.length !== this.elements.length) {
                if (this.aiGalleryData.story[0].listImages.length > this.elements.length) {
                    const elementsToAdd = this.aiGalleryData.story[0].listImages.length - this.elements.length;
                    for (let i = 0; i < elementsToAdd; i++) {
                        this.elements.push(this.elements[this.elements.length - 1]);
                    }
                }
                else {
                    const elementsToDelete = this.elements.length - this.aiGalleryData.story[0].listImages.length;
                    this.elements.splice(this.elements.length - elementsToDelete, elementsToDelete);
                }
            }
            this.elements.pop();
            const apiRequests = this.aiGalleryData.story[0].listImages.map((image) => {
                const imagePath = this.wireImageDisplayUrl + this.aiGalleryData.location + '/' + image.src;
                //const imagePath = this.wireImageDisplayUrl + 'ai/img/2023/3/28' + '/' + '1--Get-Your-Beauty-Rest-.jpeg';
                const fd = new FormData();
                fd.set('file', imagePath);
                return this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd);
            });
            forkJoin(apiRequests).subscribe((responses) => {
                const payload = responses.map((response) => {
                    this.imageData2 = response;
                    let imageUrl = this.imageData2.images.original;
                    this.isAIimge = true;
                    this.uploadImageInProgress = false;
                    const reader = new FileReader();
                    imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + imageUrl;
                    this.sharedService.getImage(imageUrl).subscribe(file => {
                        const a = reader.readAsDataURL(file);
                        reader.onload = (e) => {
                            this.cropperImageUrl.data = e.target.result;
                            this.cropperImageUrl.url = imageUrl;
                            return this.showCropper.push({ crop: true, cropperImageUrl: cloneDeep(this.cropperImageUrl) });
                        };
                    });
                });
            });
        }
    }
    uploadWebStory(template) {
        this.snotify.info('Picking Domain Template and Uploading Web Story Please Wait...', '', Object.assign({}, this.sharedService.getConfig(false), { timeout: 10000 }));
        let newWebStory = cloneDeep(template);
        let templateSlides = [];
        let webstorySlides = [];
        let newElements = [];
        const processingPromises = [];
        if (newWebStory && newWebStory.elements && newWebStory.elements.length > 0 &&
            this.webstoryData && this.webstoryData.elements.length > 0) {
            let templateElements = newWebStory.elements;
            let webstoryElements = this.webstoryData.elements;
            this.elements = newWebStory.elements;
            if (this.webstoryData.elements.length !== this.elements.length) {
                if (this.webstoryData.elements.length > this.elements.length) {
                    const elementsToAdd = this.webstoryData.elements.length - this.elements.length;
                    for (let i = 0; i < elementsToAdd; i++) {
                        this.elements.push(this.elements[this.elements.length - 1]);
                    }
                }
                else {
                    const elementsToDelete = this.elements.length - this.webstoryData.elements.length;
                    this.elements.splice(this.elements.length - elementsToDelete, elementsToDelete);
                }
                this.elements.pop();
            }
            this.restService.http_post(this.config.get('product').baseUrl
                + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.all_element_api), templateElements, res => {
                if (res && (res !== null) && !res.hasOwnProperty('error')) {
                    templateSlides = res;
                    this.restService.http_post(this.config.get('product').baseUrl
                        + this.config.getEndPoint(this.config.get('views'), this.story_page_id, this.all_element_api), webstoryElements, result => {
                        if (result && (result !== null) && !res.hasOwnProperty('error')) {
                            webstorySlides = result;
                            // console.log("Template Slides: " ,templateSlides);
                            // console.log("Web Slides: " ,webstorySlides); 
                            this.webStory.summary = this.webstoryData.summary;
                            this.webStory.title = this.webstoryData.title;
                            this.webStory.headline = this.webstoryData.headline;
                            this.webStoryHeadline.emit(this.webstoryData.headline);
                            this.webStorySummary.emit(this.webstoryData.headline);
                            this.webStory.summary = this.webstoryData.headline;
                            this.webStory.mobileHeadline = this.webstoryData.headline;
                            this.webStory.urlHeadline = this.webstoryData.headline;
                            this.webStory.slideAnimation = this.webstoryData.slideAnimation;
                            // console.log(this.webstoryData.leadMedia);
                            const coverImageUploadPromise = this.http.post(this.config.get('product').imageUploadUrl +
                                "/api/image/copyImage/byurl?domainFrom=" + this.webstoryData.domainId, this.webstoryData.leadMedia.image)
                                .toPromise().then(response => {
                                console.log(response);
                                this.createUploadedCoverImageElement(this.webstoryData.leadMedia.image.ampFlag, this.webstoryData.leadMedia.image.verticalFlag, response['images'], null);
                            });
                            processingPromises.push(coverImageUploadPromise);
                            let index = 0;
                            for (let element of webstorySlides) {
                                element.id = null;
                                element.logoUrl = this.logoUrl;
                                element.domainId = this.domainConfig['domainId'];
                                if (element.hasSlideImage) {
                                    const imageUploadPromise = this.http.post(this.config.get('product').imageUploadUrl +
                                        "/api/image/copyImage/byurl?domainFrom=" + this.webstoryData.domainId, element.image)
                                        .toPromise()
                                        .then(response => {
                                        element.image.images = response.hasOwnProperty('images') ? response['images'] : null;
                                        element.hasSlideImage = true;
                                    });
                                    processingPromises.push(imageUploadPromise);
                                }
                                if (element.hasSlideVideo) {
                                    let ele = cloneDeep(element.image);
                                    ele.images = { 'url': element.video.url };
                                    const imageUploadPromise = this.http.post(this.config.get('product').imageUploadUrl +
                                        "/api/image/copyImage/byurl?domainFrom=" + this.webstoryData.domainId, ele)
                                        .toPromise()
                                        .then(response => {
                                        element.video.url = response.hasOwnProperty('images') ? response['images']['url'] : null;
                                        element.hasSlideVideo = true;
                                    });
                                    processingPromises.push(imageUploadPromise);
                                }
                                if (element.webStorySlide && element.webStorySlide.length > 0) {
                                    let arr = templateSlides[index].webStorySlide;
                                    if (element.webStorySlide.length > arr.length) {
                                        element.webStorySlide.splice(arr.length); // Discard extra slides
                                    }
                                    if (arr.length > element.webStorySlide.length) {
                                        arr.splice(element.webStorySlide.length);
                                    }
                                    for (let i = 0; i < arr.length; i++) {
                                        const newSlide = Object.assign({}, templateSlides[index].webStorySlide[i], { text: element.webStorySlide[i].text // Update the text property
                                         });
                                        element.webStorySlide[i] = newSlide;
                                    }
                                }
                                index++;
                                if (element && element.webStorySlide != null && element.webStorySlide.length > 0) {
                                    element.webStorySlide.forEach((ele) => {
                                        if (ele.fontSize.indexOf('px') > -1) {
                                            ele.fontSize = ((+(ele.fontSize.replace('px', ''))) * 0.0625) + 'em';
                                            if (ele.textboxCSS != null || ele.textboxCSS == undefined) {
                                                ele.textboxCSS['font-size'] = ele.fontSize;
                                            }
                                        }
                                    });
                                }
                                newElements.push(element);
                            }
                            Promise.all(processingPromises)
                                .then(() => {
                                this.slideIds = [];
                                this.saveMultipleSlides(newElements, template); // Updated elements
                            })
                                .catch(error => {
                                this.snotify.error("Failed to upload web story", '', this.sharedService.getConfig(false));
                                console.error("Error processing elements:", error);
                            });
                        }
                    });
                }
            });
        }
    }
    saveMultipleSlides(newElements, template) {
        // console.log("check save1");
        let manualElementSaveRequests = [];
        const optionsManual = StaticDataService.options;
        const len = newElements.length;
        for (let element of newElements) {
            if (len > 0) {
                const token = localStorage.getItem(StaticDataService.tokenLiteral) ?
                    JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))
                    : null;
                const url = this.config.get('product').baseUrl
                    + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api);
                manualElementSaveRequests.push(this.http.post(url, JSON.stringify(element ? element : {}), optionsManual));
            }
        }
        this.slides = {};
        forkJoin(manualElementSaveRequests).subscribe(resultOfManualSave => {
            resultOfManualSave.filter(e => (e && e.hasOwnProperty('id') && !e.hasOwnProperty('error'))).forEach(response => {
                if (response) {
                    this.slides[response['id']] = response;
                    this.slideIds.push(response['id']);
                }
            });
            if (template) {
                this.currentSlideIndex = 0;
                this.slides = cloneDeep(this.slides);
                // let previousStoryData = cloneDeep(this.webStory);
                // this.webStory = cloneDeep(template);
                // this.storyContainerService.retainStoryData(this.webStory, previousStoryData);
                // this.webStory.id=previousStoryData.id;
                // this.webStory.webStoryTemplate = false;
                // this.webStory.coverImageUrl = null;
                this.webStory.elements = [...this.slideIds];
                this.replaceElementData.emit(this.slides);
                this.updateStoryData.emit(this.webStory);
                this.emptyWebStory = false;
            }
            else {
                this.slides = cloneDeep(this.slides);
                this.webStory.elements = [...this.slideIds];
                this.updateStoryData.emit(this.webStory);
            }
            this.currentSlideElement = cloneDeep(this.slides[this.webStory.elements[this.currentSlideIndex]]);
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            this.currentTextboxOrButtonElements = this.currentSlideElement ? this.currentSlideElement['webStorySlide'] : null;
        }, err => {
        });
    }
    sequenceChanged() {
        console.log(this.slideIds);
        this.webStory.elements = [...this.slideIds];
        this.changeCurrentSlide(this.currentSlideIndex);
    }
    linkOptionClick(index) {
        this.buttonUrl = this.currentTextboxOrButtonElements[index].url;
        this.linkBoxInput = true;
    }
    closeLinkOptionClick() {
        this.linkBoxInput = false;
        this.buttonUrl = null;
    }
    updateWebStoryButtonUrl(index) {
        this.currentTextboxOrButtonElements[index].url = cloneDeep(this.buttonUrl);
        this.updateSlide(res => { });
    }
    deleteVideoAndImage() {
        if (!this.textboxInProgress) {
            this.deleteBackgroundImage();
            this.deleteVideo();
            this.updateSlide(res => { });
        }
    }
    deleteBackgroundImage() {
        if (this.currentSlideElement.image && this.currentSlideElement.image.images && this.currentSlideElement.image.images['original']) {
            //this.currentSlideElement.image.images['original'] = null;
            this.currentSlideElement.image.images = { "original": null };
            this.currentSlideElement.hasSlideImage = false;
        }
        if (this.currentSlideElement.image && this.currentSlideElement.image.caption) {
            this.currentSlideElement.image.caption = null;
        }
        //this.updateSlide(res => {});
    }
    deleteVideo() {
        if (this.currentSlideElement.video && this.currentSlideElement.video.url) {
            this.currentSlideElement.video.url = null;
            this.currentSlideElement.hasSlideVideo = false;
        }
        if (this.currentSlideElement.video && this.currentSlideElement.video.image && this.currentSlideElement.video.image.caption) {
            this.currentSlideElement.video.image.caption = null;
        }
        //this.updateSlide(res => {});
    }
    copyCurrentTextboxOrButton(index) {
        if (index != null && index > -1 && index < this.currentSlideElement['webStorySlide'].length) {
            this.copiedTextboxOrButton = cloneDeep(this.currentSlideElement['webStorySlide'][index]);
            this.snotify.info('selected Textbox copied clipboard', '', this.sharedService.getConfig(false));
        }
        else if (this.currentTextboxOrButtonElementIndex != null && this.currentTextboxOrButtonElementIndex > -1) {
            this.copiedTextboxOrButton = cloneDeep(this.currentSlideElement['webStorySlide'][this.currentTextboxOrButtonElementIndex]);
            this.snotify.info('selected Textbox copied clipboard', '', this.sharedService.getConfig(false));
        }
    }
    pasteCopiedCurrentTextboxOrButton() {
        if (!this.textboxInProgress) {
            if (this.copiedTextboxOrButton) {
                if (this.currentTextboxOrButtonElements) {
                    this.currentTextboxOrButtonElements.push(cloneDeep(this.copiedTextboxOrButton));
                    this.currentSlideElement ? this.currentSlideElement['webStorySlide'] = this.currentTextboxOrButtonElements : null;
                }
                else {
                    this.currentTextboxOrButtonElements = new Array();
                    this.currentTextboxOrButtonElements.push(this.copiedTextboxOrButton);
                    this.currentSlideElement ? this.currentSlideElement['webStorySlide'] = this.currentTextboxOrButtonElements : null;
                }
                this.currentSlideWords = this.getWordCountOfCurrentsSlide();
                this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElements.length - 1].textboxCSS = cloneDeep(this.getStyles(this.currentTextboxOrButtonElements.length - 1));
                this.updateSlide(res => { });
                this.snotify.info('selected Textbox pasted from clipboard', '', this.sharedService.getConfig(false));
            }
            else {
                this.snotify.info('Please copy Textbox to clipboard first', '', this.sharedService.getConfig(false));
            }
        }
    }
    getWordCountOfCurrentsSlide() {
        return this.getWordCountInSlide(null);
    }
    countWords(str) {
        str = str.replace(/(^\s*)|(\s*$)/gi, "");
        str = str.replace(/[ ]{2,}/gi, " ");
        str = str.replace(/\n /, "\n");
        return str.split(' ').length;
    }
    getWordCountInSlide(slideId) {
        let slide;
        let textboxOrButtonElements;
        let str = '';
        if (slideId) {
            slide = this.slides[slideId];
        }
        else {
            slide = this.currentSlideElement;
        }
        if (slide) {
            textboxOrButtonElements = slide['webStorySlide'];
        }
        if (textboxOrButtonElements && textboxOrButtonElements.length > 0) {
            textboxOrButtonElements.forEach((el) => {
                if (el.text) {
                    str = str + ' ' + el.text;
                }
            });
        }
        //add creditbox string
        if (slide && slide.creditInfo) {
            str = str + ' ' + slide.creditInfo;
        }
        if (str && str.length > 0) {
            return this.countWords(str);
        }
        else {
            return '0';
        }
    }
    insertCoverImage() {
        this.coverImageEnabled = true;
    }
    closeCoverImage() {
        this.coverImageEnabled = false;
    }
    convertHTMLToPlainText(index) {
        let currentTextboxOrButton = this.currentTextboxOrButtonElements[index];
        let str = cloneDeep(currentTextboxOrButton.text);
        this.currentTextboxOrButtonElements[index].text = this.htmlToPlaintext(str);
        this.updateSlide(res => { });
    }
    htmlToPlaintext(text) {
        if (typeof text === 'string') {
            return text ? this.htmlSpecialCharToText(String(text).replace(/<[^>]+>/gm, '')) : '';
        }
        else {
            return text;
        }
    }
    htmlSpecialCharToText(text) {
        // const tevbrgvr = '&nbsp;&amp;&quot;&lt;&gt;';
        const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
        const translate = {
            'nbsp': ' ',
            'amp': '&',
            'quot': '\'',
            'lt': '<',
            'gt': '>'
        };
        return (text.replace(translate_re, (match, entity) => {
            return translate[entity];
        }));
    }
    updateSlideMetaTitle(event) {
        (this.currentSlideElement['metaTitle'] && this.currentSlideElement['metaTitle'] != '') ? this.currentSlideElement['metaTitle'].replace(/\&nbsp;/g, '') : null;
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateSlideAnimation(event) {
        this.updateSlide(res => { });
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateSlideMetaDescription(event) {
        (this.currentSlideElement['metaDescription'] && this.currentSlideElement['metaDescription'] != '') ? this.currentSlideElement['metaDescription'].replace(/\&nbsp;/g, '') : null;
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateCtaText(event) {
        (this.currentSlideElement['ctaText'] && this.currentSlideElement['ctaText'] != '') ? this.currentSlideElement['ctaText'].replace(/\&nbsp;/g, '') : null;
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateCtaLink(event) {
        (this.currentSlideElement['ctaLink'] && this.currentSlideElement['ctaLink'] != '') ? this.currentSlideElement['ctaLink'].replace(/\&nbsp;/g, '') : null;
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateAltText(event) {
        (this.currentSlideElement['altText'] && this.currentSlideElement['altText'] != '') ? this.currentSlideElement['altText'].replace(/\&nbsp;/g, '') : null;
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateCreditInfo(event) {
        (this.currentSlideElement['creditInfo'] && this.currentSlideElement['creditInfo'] != '') ? this.currentSlideElement['creditInfo'].replace(/\&nbsp;/g, '') : null;
        this.currentSlideWords = this.getWordCountOfCurrentsSlide();
        this.updateSlide(res => { });
        this.currentEditDataType = null;
        if (event && event.relatedTarget && event.relatedTarget.id) {
            event.relatedTarget.click();
        }
    }
    updateSlideKeywords(event) {
        this.currentSlideElement['keywords'] = event;
        this.updateSlide(res => { });
    }
    widthChange(value) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].width = value + '%';
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].leftRightCenter = false;
        this.setLeftMargin('0%', 'auto');
    }
    topPaddingChange(value) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topPadding = value + '%';
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = false;
        this.setTopMargin('0%', 'auto');
    }
    bottomPaddingChange(value) {
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].bottomPadding = value + '%';
        this.currentTextboxOrButtonElements[this.currentTextboxOrButtonElementIndex].topBottomCenter = false;
        this.setBottomMargin('0%', 'auto');
    }
    focusDropdown() {
        this.isDropDownOpen = true;
    }
    blurDropdown() {
        console.log("dropdown blur");
        this.isDropDownOpen = false;
        // event.target.id = this.currentSlideElement.id+'textboxOrButton'+this.currentTextboxOrButtonElementIndex;
        // this.setTextboxOrButtonValue(event,cloneDeep(this.currentTextboxOrButtonElementIndex));
        this.focusTextboxOrButton('dropdown blur');
    }
    googleAnalytics(eventCategory, eventAction, eventLabel, eventValue) {
        this.gaService.gaEventView(eventCategory, eventAction, eventLabel, eventValue);
    }
    openRelatedStoryPopup() {
        let navigationSlideId = null;
        if (this.slides && Object.keys(this.slides).length > 0 && this.slideIds && this.slideIds.length > 0) {
            this.slideIds.forEach(id => {
                let slideElement = this.slides[id];
                if (slideElement != null && slideElement.relatedStoryData && slideElement.relatedStoryData.length > 0) {
                    navigationSlideId = id;
                    this.navigationSlideId = cloneDeep(id);
                }
            });
        }
        if (navigationSlideId != null) {
            this.snotify.error('Navigation Slide already present', '', this.sharedService.getConfig(false));
        }
        else {
            this.relatedStoryType = 'web-story';
            this.showRelatedStoryPopup = true;
            if (this.webStory && this.webStory.id) {
                this.storyId = this.webStory.id;
            }
            this.sharedService.overflowhidden();
        }
    }
    closeRelatedStoryModal(event) {
        this.showRelatedStoryPopup = false;
        this.sharedService.overflowauto();
    }
    getRelatedStoryData(event) {
        console.log("related story data" + event);
        if (event && event.length > 4) {
            this.snotify.error('Maximum 4 stories can be selected, please deselect some stories', '', this.sharedService.getConfig(false));
        }
        else {
            this.setRelatedStoryData(event);
        }
    }
    setRelatedStoryData(stories) {
        let relatedStories = [];
        stories.forEach((story) => {
            let relatedStoryData = new RelatedStoryData();
            relatedStoryData.id = story.id;
            relatedStoryData.coverImageUrl = story.coverImageUrl;
            relatedStoryData.title = story.mobileHeadline;
            relatedStoryData.url = this.getStoryUrl(story);
            relatedStories.push(relatedStoryData);
        });
        this.insertNavigationSlideOnEnd(relatedStories);
    }
    insertNavigationSlideOnEnd(relatedStories) {
        if (!this.textboxInProgress) {
            this.currentSlideElement = JSON.parse(JSON.stringify(StaticDataService.defaultSlideData));
            this.currentSlideElement.relatedStoryData = cloneDeep(relatedStories);
            this.currentSlideElement.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
            this.currentSlideElement.type = 'slide';
            this.currentSlideIndex = this.slideIds.length;
            this.currentSlideWords = this.getWordCountOfCurrentsSlide();
            this.useLogo("Top-Left");
            this.saveNewSlide("right");
            this.closeRelatedStoryModal(null);
        }
    }
    currentNavigationSlide() {
        if (this.navigationSlideId != null && this.currentSlideElement != null && this.currentSlideElement.id != null) {
            if (this.navigationSlideId === this.currentSlideElement.id) {
                return true;
            }
        }
        return false;
    }
    checkForNavigationSlide() {
        if (this.slides && Object.keys(this.slides).length > 0 && this.slideIds && this.slideIds.length > 0) {
            this.slideIds.forEach(id => {
                let slideElement = this.slides[id];
                if (slideElement != null && slideElement.relatedStoryData && slideElement.relatedStoryData.length > 0) {
                    this.navigationSlideId = cloneDeep(id);
                }
            });
        }
    }
    getStoryUrl(storyData) {
        if (storyData && storyData.metadata && storyData.metadata.status && storyData.metadata.status !== 'KILLED') {
            if (storyData.metadata.url) {
                if (storyData.metadata.url.charAt(0) !== '/' && storyData.metadata.url.substring(0, 4) !== 'http') {
                    return storyData.metadata.url;
                }
                else {
                    if (this.sharedService.currentDomainUrl === null || this.sharedService.currentDomainUrl === undefined || this.sharedService.currentDomainUrl.trim() === '') {
                        let obj = environment.domainBaseUrls.filter(e => e.id === sessionStorage.getItem(StaticDataService.domainLiteral));
                        if (obj)
                            return obj[0].baseUrl + storyData.metadata.url;
                        return '';
                    }
                    else {
                        return this.sharedService.currentDomainUrl + storyData.metadata.url;
                    }
                }
            }
            else {
                return '';
            }
        }
        else {
            return storyData.metadata.redirectUrl;
        }
    }
    //  getRelatedStoryIds(event)
    //  {
    //   console.log("related story ids"+event);
    //  }
    openAmazonAdSearchPopup() {
        this.amazonAdSearchPopup = true;
        this.sharedService.overflowhidden();
    }
    closeAmazonAdSearchPopup(event) {
        this.amazonAdSearchPopup = false;
        this.sharedService.overflowauto();
    }
    getAmazonEmbedStoryIds(ev) {
        //this.dataFormAmazonList.push([...ev]);
        if (ev && ev.length > 0 && ev[0].data && ev[0].data.productAffiliateUrl != null) {
            this.currentSlideElement.ctaLinkWithUtm = cloneDeep(ev[0].data.productAffiliateUrl);
            this.currentSlideElement.ctaLink = cloneDeep(ev[0].data.productAffiliateUrl);
            this.updateSlide(res => {
                this.snotify.success('Affiliate CTA link added', '', this.sharedService.getConfig(false));
            });
        }
        this.closeAmazonAdSearchPopup(null);
    }
}
